import React, { useState, useEffect }  from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from "formik";
import * as Yup from "yup";

import messages from '../../../../assets/locale/messages';
import RadioButtonsGroup from '../../../../components/RadioButton'
import Modal from '../../../../components/Modal'
import { editBookingServiceRequest, getRequestStatus } from '../../../../store/Bookings/actions'

const BookingServiceCancelationReasonForm = ({open, setOpen, cancelService}) => {

    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const { bookings, shared} = messages[lang];
    const bookingServiceCancelationReasons = useSelector((state) => state.bookings.bookingServiceCancelationReasons);
    const [bookingServiceCancelationReasonsList, setBookingServiceCancelationReasonsList] = useState([]);
    const [selectedReasonObject, setSelectedReasonObject] = useState(null);
    const [showNoRefundExceptionalPopup, setShowNoRefundExceptionalPopup] = useState(false);
    const [pendingReasonId, setPendingReasonId] = useState(null);

    const isCustomerSideReason = (reason) => {
        if (!reason) return false;
        return ['customer_no_longer_wants_this_service', 'customer_is_late'].includes(reason.key);
    };

    const dispatchCancelService = (reasonId, applyRefund) => {
        dispatch(editBookingServiceRequest({
            id: cancelService.id,
            data: {
                appointment_branch_service_cancellation_reason_id: reasonId,
                apply_refund: applyRefund,
            }
        }));
        dispatch(getRequestStatus(false));
    };

    const {
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        touched,
        errors,
        resetForm,
        } = useFormik({
            initialValues:{
                cancelationReason: ""
            },
            validationSchema: Yup.object({
                cancelationReason: Yup.string().required('Required')
            }),
            onSubmit: ({ cancelationReason }) => {
                const reasonId = +cancelationReason;
                setPendingReasonId(reasonId);
                closeForm();

                if (isCustomerSideReason(selectedReasonObject)) {
                    setShowNoRefundExceptionalPopup(true);
                } else {
                    dispatchCancelService(reasonId, true);
                }
            }
     });

    const closeForm = () => {
        setOpen(false);
        setSelectedReasonObject(null);
        resetForm();
    };

    const closeExceptionalPopup = () => {
        setPendingReasonId(null);
        setShowNoRefundExceptionalPopup(false);
    };

    useEffect(()=>{
        const reasons = (bookingServiceCancelationReasons || []).map(reason => ({
            id: reason.id,
            label: (
                <div className="fsize-20 fweight-400 text-gray">
                    {lang === 'en' ? reason.reason_en : reason.reason_ar}
                </div>
            ),
            value: String(reason.id)
        }))
        setBookingServiceCancelationReasonsList([...reasons]);
    },[lang, bookingServiceCancelationReasons]);

    const handleCloseCancelationReasonPopup = () => {
        closeForm();
    };

    const renderCancelationReasonPopupContent = () => (
        <div>
            <div className="fsize-20 fweight-400 mb-3">{bookings.details.serviceCancelationReasonLabel}*</div>
            <RadioButtonsGroup
                name="cancelationReason"
                labelId="cancelationReason"
                value={selectedReasonObject ? String(selectedReasonObject.id) : ""}
                list={bookingServiceCancelationReasonsList}
                onChange={(e) => {
                    setFieldTouched("cancelationReason");
                    setFieldValue("cancelationReason", e.target.value);
                    const reason = bookingServiceCancelationReasons?.find(r => String(r.id) === e.target.value);
                    setSelectedReasonObject(reason || null);
                  }}
            />
            {selectedReasonObject && !isCustomerSideReason(selectedReasonObject) && (
                <div className="fsize-16 fweight-400 text-success mt-2">
                    {bookings.details.serviceAutoPartialRefundInfo}
                </div>
            )}
        </div>
    )

    return(
        <>
            <Modal
                open={open}
                handleClose={handleCloseCancelationReasonPopup}
                title={<span className="fsize-26 fweight-400">{bookings.details.cancelService}</span>}
                contentClass="mb-3 pb-2 text-primary"
                content={renderCancelationReasonPopupContent()}
                confirmBtnTxt={shared.submit}
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleSubmit}
                handleCancel={handleCloseCancelationReasonPopup}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
                cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
                disableActionBtn={!!(!touched["cancelationReason"] || errors["cancelationReason"])}
            />

            <Modal
                open={showNoRefundExceptionalPopup}
                handleClose={closeExceptionalPopup}
                title={<span className="fsize-26 fweight-400">{bookings.details.cancelService}</span>}
                contentClass="mb-3 pb-2 text-primary"
                content={<span className="fsize-20 fweight-400">{bookings.details.customerNoShowPopupContent}</span>}
                confirmBtnTxt={shared.ok}
                cancelBtnTxt={bookings.details.refundAnyways}
                isContentText={false}
                handleConfirm={() => {
                    dispatchCancelService(pendingReasonId, false);
                    closeExceptionalPopup();
                }}
                handleCancel={() => {
                    dispatchCancelService(pendingReasonId, true);
                    closeExceptionalPopup();
                }}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
                cancelBtnClass="fsize-14 py-2 text-secondary px-5"
            />
        </>
    )
}

export default BookingServiceCancelationReasonForm;
